import React, { useContext, useEffect, useState } from 'react'
import PubSub from '@paytrace/pt-skel/Event/PubSub'
import { AppCtx } from '@paytrace/pt-skel/Context'
import RecurringBaseLayout from '../../Component/Recurring/RecurringBaseLayout'
import RecurForm from '../../Component/Recurring/RecurForm'
import { useRecurFormLogic } from '../../hooks/useRecurFormLogic'
import Event from '../../Event'
import { Customer } from '../../types'
import { Fieldset, Legend } from '@paytrace/pt-skel/Component'
import RecurringCustomerSelect, { CustomerSelectProps } from '../../Component/Recurring/RecurringCustomerSelect'
import StateCheckAlert from '../../Component/Recurring/StateCheckAlert'

const self = Symbol('RecurCreate')

export default function RecurCreate (): React.ReactElement {
  const context = useContext(AppCtx)
  const [customer, setCustomer] = useState<Customer | null>(null)

  const {
    formData,
    handleChange,
    handleSubmit,
    handleDelete,
    showValidationErrors,
    supportedRecurTranxTypes,
    supportedStdEntryClasses,
    achMerchantSettings,
    minDate,
    recurResponse,
    isLoading,
    disableSubmit,
    showSurchargeInfo,
    customerAchDetails,
    isStateCheckAlertOpen,
    setIsStateCheckAlertOpen,
    isStateSurchargeAvailable,
    isStateAvailable,
  } = useRecurFormLogic({
    isEditMode: false,
    customer,
  })

  const [searchObj] = useState<CustomerSelectProps['searchObject']>({
    limit: 250,
    offset: 0,
    merchantId: context.merchant,
    name_filter: '',
  })

  useEffect(() => {
    const handleCustomerResponse = (data: { customer: Customer } | null) => {
      if (data?.customer) {
        setCustomer(data.customer)
      } else {
        setCustomer(null)
      }
    }

    PubSub.sub(self, Event.GET_CUSTOMER_RESPONSE, handleCustomerResponse)

    return () => {
      PubSub.unsub(Event.GET_CUSTOMER_RESPONSE)
    }
  }, [])

  return (
    <RecurringBaseLayout
      title="New Recurring Payment"
      helpLink="https://paytrace.atlassian.net/wiki/spaces/HD/pages/2027487634/New+Payment" // Update link if needed
    >
      {recurResponse.message && (
        <div className={recurResponse.status === 'success' ? 'success' : 'error'}>
          {recurResponse.message}
        </div>
      )}

      {!recurResponse.message || recurResponse.status !== 'success'
        ? (
        <>
          {showValidationErrors()}

          <Fieldset>
            <Legend title="Select Customer" />
            <RecurringCustomerSelect
              searchObject={searchObj}
              onCustomerSelect={setCustomer}
            />
          </Fieldset>

          <RecurForm
            formData={formData}
            handleChange={handleChange}
            handleSubmit={handleSubmit}
            supportedRecurTranxTypes={supportedRecurTranxTypes}
            supportedStdEntryClasses={supportedStdEntryClasses}
            achMerchantSettings={achMerchantSettings}
            minDate={minDate}
            isEditPage={false}
            isLoading={isLoading}
          submitDisabled={disableSubmit}
          showSurchargeInfo={showSurchargeInfo}
          customerAchDetails={customerAchDetails}
          />
          <StateCheckAlert
            isOpen={isStateCheckAlertOpen}
            setIsOpen={() => setIsStateCheckAlertOpen(false)}
            isSurchargeAvailable={isStateSurchargeAvailable}
            isStateAvailable={isStateAvailable}
          />
        </>
          )
        : (
        <></>
          )}
    </RecurringBaseLayout>
  )
}
